var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAlertError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 46 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#E21664",
    d: "M45.886,42.536 L23.886,0.536 C23.541,-0.123 22.459,-0.123 22.115,0.536 L0.115,42.536 C-0.048,42.846 -0.036,43.218 0.145,43.517 C0.326,43.816 0.65,44 1,44 L45,44 C45.35,44 45.674,43.817 45.855,43.518 C46.036,43.219 46.048,42.846 45.886,42.536 Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    stroke: "#FFF",
    d: "M22,17 C22,16.448 22.448,16 23,16 C23.552,16 24,16.448 24,17 L24,30 C24,30.552 23.552,31 23,31 C22.448,31 22,30.552 22,30 L22,17 Z M23,38 C21.895,38 21,37.105 21,36 C21,34.895 21.895,34 23,34 C24.105,34 25,34.895 25,36 C25,37.105 24.105,38 23,38 Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlertError);
export default __webpack_public_path__ + "static/media/alert-error.98824e55699a8b976c6e09e2bc5d6ef6.svg";
export { ForwardRef as ReactComponent };